import { render, staticRenderFns } from "./PaddleCredentials.vue?vue&type=template&id=2b56ed25&"
import script from "./PaddleCredentials.vue?vue&type=script&lang=js&"
export * from "./PaddleCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports